import React from "react";
import * as LucideIcons from "lucide-react";
import { HelpCircle } from "lucide-react";

const LUCIDE_ICON_MAP = new Map(Object.entries(LucideIcons));

function Icon({
  name,
  size = 24,
  color = "currentColor",
  className = "",
  strokeWidth = 2,
  ...props
}) {
  const IconComponent = LUCIDE_ICON_MAP.get(name);

  if (!IconComponent) {
    return React.createElement(HelpCircle, {
      ...props,
      size,
      color: "gray",
      strokeWidth,
      className,
    });
  }

  return React.createElement(IconComponent, {
    ...props,
    size,
    color,
    strokeWidth,
    className,
  });
}
export default Icon;
